// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-profile-page {
  --my-profile-bg: #f7efe3;
  --my-profile-ink: #241b12;
  --my-profile-card: #fffaf4;
  --my-profile-border: #e9d8c1;
  --my-profile-accent: #0f7f73;
  --my-profile-accent-2: #f47f3d;
  background: radial-gradient(circle at 12% 14%, rgba(244, 127, 61, 0.14), transparent 44%), radial-gradient(circle at 84% 26%, rgba(15, 127, 115, 0.16), transparent 42%), linear-gradient(180deg, #fdf7ed 0%, var(--my-profile-bg) 100%);
  min-height: 100%;
  padding: 24px;
  color: var(--my-profile-ink);
}

.my-profile-hero {
  position: relative;
  overflow: hidden;
  border: 1px solid #d6c1a5;
  border-radius: 22px;
  background: linear-gradient(125deg, rgba(36, 27, 18, 0.98) 0%, rgba(56, 40, 25, 0.95) 48%, rgba(15, 127, 115, 0.9) 100%);
  margin-bottom: 20px;
  box-shadow: 0 16px 44px rgba(37, 26, 16, 0.32);
  animation: profileHeroRise 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.my-profile-hero__content {
  position: relative;
  z-index: 2;
  padding: 28px;
}

.my-profile-overline {
  color: #f6ddbf;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-weight: 700;
  font-size: 11px;
}

.my-profile-title.ant-typography {
  color: #fff2dc;
  margin: 8px 0 4px 0;
  line-height: 1.1;
}

.my-profile-subtitle {
  color: #ffe9cc;
  max-width: 760px;
  display: block;
}

.my-profile-hero__actions {
  margin-top: 16px;
}

.my-profile-hero__glow {
  position: absolute;
  border-radius: 999px;
  filter: blur(4px);
}

.my-profile-hero__glow--one {
  width: 280px;
  height: 280px;
  right: -80px;
  top: -120px;
  background: radial-gradient(circle at center, rgba(244, 127, 61, 0.45), rgba(244, 127, 61, 0.06));
}

.my-profile-hero__glow--two {
  width: 260px;
  height: 260px;
  right: 130px;
  bottom: -150px;
  background: radial-gradient(circle at center, rgba(15, 127, 115, 0.42), rgba(15, 127, 115, 0.06));
}

.my-profile-card.ant-card {
  border-radius: 16px;
  border-color: var(--my-profile-border);
  background: var(--my-profile-card);
  box-shadow: 0 9px 28px rgba(28, 20, 14, 0.1);
  animation: profileCardLift 560ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.my-profile-column--form .my-profile-card.ant-card {
  animation-delay: 120ms;
}

.my-profile-column--panels .my-profile-card.ant-card {
  animation-delay: 200ms;
}

.my-profile-panels .ant-collapse-item {
  animation: profileCardLift 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.my-profile-panels .ant-collapse-item:nth-child(1) {
  animation-delay: 120ms;
}

.my-profile-panels .ant-collapse-item:nth-child(2) {
  animation-delay: 160ms;
}

.my-profile-panels .ant-collapse-item:nth-child(3) {
  animation-delay: 200ms;
}

.my-profile-panels .ant-collapse-item:nth-child(4) {
  animation-delay: 240ms;
}

.my-profile-panels .ant-collapse-item:nth-child(5) {
  animation-delay: 280ms;
}

.my-profile-panels .ant-collapse-item:nth-child(6) {
  animation-delay: 320ms;
}

.my-profile-panels .ant-collapse-item:nth-child(7) {
  animation-delay: 360ms;
}

.my-profile-panels .ant-collapse-item:nth-child(8) {
  animation-delay: 400ms;
}

@keyframes profileHeroRise {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes profileCardLift {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .my-profile-hero,
  .my-profile-card.ant-card,
  .my-profile-panels .ant-collapse-item {
    animation: none !important;
  }
}
.my-profile-card .ant-card-head-title {
  color: #3d2b18;
  font-weight: 700;
}

.my-profile-card .ant-btn-primary {
  background: var(--my-profile-accent);
  border-color: var(--my-profile-accent);
}

.my-profile-card .ant-btn-primary:hover,
.my-profile-card .ant-btn-primary:focus {
  background: #0c6b61;
  border-color: #0c6b61;
}

@media (max-width: 768px) {
  .my-profile-page {
    padding: 14px;
  }
  .my-profile-hero__content {
    padding: 18px;
  }
  .my-profile-subtitle {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/profile/MyProfilePage.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,4BAAA;EACA,8BAAA;EAEA,wOACE;EAGF,gBAAA;EACA,aAAA;EACA,4BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,wHACE;EACF,mBAAA;EACA,8CAAA;EACA,oEAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AAJF;;AAOA;EACE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAJF;;AAOA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,iGAAA;AAJF;;AAOA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,iGAAA;AAJF;;AAOA;EACE,mBAAA;EACA,sCAAA;EACA,kCAAA;EACA,4CAAA;EACA,oEAAA;AAJF;;AAOA;EACE,sBAAA;AAJF;;AAOA;EACE,sBAAA;AAJF;;AAOA;EACE,oEAAA;AAJF;;AAOA;EAAqD,sBAAA;AAHrD;;AAIA;EAAqD,sBAAA;AAArD;;AACA;EAAqD,sBAAA;AAGrD;;AAFA;EAAqD,sBAAA;AAMrD;;AALA;EAAqD,sBAAA;AASrD;;AARA;EAAqD,sBAAA;AAYrD;;AAXA;EAAqD,sBAAA;AAerD;;AAdA;EAAqD,sBAAA;AAkBrD;;AAhBA;EACE;IACE,UAAA;IACA,uCAAA;EAmBF;EAhBA;IACE,UAAA;IACA,iCAAA;EAkBF;AACF;AAfA;EACE;IACE,UAAA;IACA,2BAAA;EAiBF;EAdA;IACE,UAAA;IACA,wBAAA;EAgBF;AACF;AAbA;EACE;;;IAGE,0BAAA;EAeF;AACF;AAZA;EACE,cAAA;EACA,gBAAA;AAcF;;AAXA;EACE,oCAAA;EACA,sCAAA;AAcF;;AAXA;;EAEE,mBAAA;EACA,qBAAA;AAcF;;AAXA;EACE;IACE,aAAA;EAcF;EAXA;IACE,aAAA;EAaF;EAVA;IACE,eAAA;EAYF;AACF","sourcesContent":[".my-profile-page {\n  --my-profile-bg: #f7efe3;\n  --my-profile-ink: #241b12;\n  --my-profile-card: #fffaf4;\n  --my-profile-border: #e9d8c1;\n  --my-profile-accent: #0f7f73;\n  --my-profile-accent-2: #f47f3d;\n\n  background:\n    radial-gradient(circle at 12% 14%, rgba(244, 127, 61, 0.14), transparent 44%),\n    radial-gradient(circle at 84% 26%, rgba(15, 127, 115, 0.16), transparent 42%),\n    linear-gradient(180deg, #fdf7ed 0%, var(--my-profile-bg) 100%);\n  min-height: 100%;\n  padding: 24px;\n  color: var(--my-profile-ink);\n}\n\n.my-profile-hero {\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #d6c1a5;\n  border-radius: 22px;\n  background:\n    linear-gradient(125deg, rgba(36, 27, 18, 0.98) 0%, rgba(56, 40, 25, 0.95) 48%, rgba(15, 127, 115, 0.9) 100%);\n  margin-bottom: 20px;\n  box-shadow: 0 16px 44px rgba(37, 26, 16, 0.32);\n  animation: profileHeroRise 460ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.my-profile-hero__content {\n  position: relative;\n  z-index: 2;\n  padding: 28px;\n}\n\n.my-profile-overline {\n  color: #f6ddbf;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  font-weight: 700;\n  font-size: 11px;\n}\n\n.my-profile-title.ant-typography {\n  color: #fff2dc;\n  margin: 8px 0 4px 0;\n  line-height: 1.1;\n}\n\n.my-profile-subtitle {\n  color: #ffe9cc;\n  max-width: 760px;\n  display: block;\n}\n\n.my-profile-hero__actions {\n  margin-top: 16px;\n}\n\n.my-profile-hero__glow {\n  position: absolute;\n  border-radius: 999px;\n  filter: blur(4px);\n}\n\n.my-profile-hero__glow--one {\n  width: 280px;\n  height: 280px;\n  right: -80px;\n  top: -120px;\n  background: radial-gradient(circle at center, rgba(244, 127, 61, 0.45), rgba(244, 127, 61, 0.06));\n}\n\n.my-profile-hero__glow--two {\n  width: 260px;\n  height: 260px;\n  right: 130px;\n  bottom: -150px;\n  background: radial-gradient(circle at center, rgba(15, 127, 115, 0.42), rgba(15, 127, 115, 0.06));\n}\n\n.my-profile-card.ant-card {\n  border-radius: 16px;\n  border-color: var(--my-profile-border);\n  background: var(--my-profile-card);\n  box-shadow: 0 9px 28px rgba(28, 20, 14, 0.1);\n  animation: profileCardLift 560ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.my-profile-column--form .my-profile-card.ant-card {\n  animation-delay: 120ms;\n}\n\n.my-profile-column--panels .my-profile-card.ant-card {\n  animation-delay: 200ms;\n}\n\n.my-profile-panels .ant-collapse-item {\n  animation: profileCardLift 420ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.my-profile-panels .ant-collapse-item:nth-child(1) { animation-delay: 120ms; }\n.my-profile-panels .ant-collapse-item:nth-child(2) { animation-delay: 160ms; }\n.my-profile-panels .ant-collapse-item:nth-child(3) { animation-delay: 200ms; }\n.my-profile-panels .ant-collapse-item:nth-child(4) { animation-delay: 240ms; }\n.my-profile-panels .ant-collapse-item:nth-child(5) { animation-delay: 280ms; }\n.my-profile-panels .ant-collapse-item:nth-child(6) { animation-delay: 320ms; }\n.my-profile-panels .ant-collapse-item:nth-child(7) { animation-delay: 360ms; }\n.my-profile-panels .ant-collapse-item:nth-child(8) { animation-delay: 400ms; }\n\n@keyframes profileHeroRise {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.99);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes profileCardLift {\n  from {\n    opacity: 0;\n    transform: translateY(18px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .my-profile-hero,\n  .my-profile-card.ant-card,\n  .my-profile-panels .ant-collapse-item {\n    animation: none !important;\n  }\n}\n\n.my-profile-card .ant-card-head-title {\n  color: #3d2b18;\n  font-weight: 700;\n}\n\n.my-profile-card .ant-btn-primary {\n  background: var(--my-profile-accent);\n  border-color: var(--my-profile-accent);\n}\n\n.my-profile-card .ant-btn-primary:hover,\n.my-profile-card .ant-btn-primary:focus {\n  background: #0c6b61;\n  border-color: #0c6b61;\n}\n\n@media (max-width: 768px) {\n  .my-profile-page {\n    padding: 14px;\n  }\n\n  .my-profile-hero__content {\n    padding: 18px;\n  }\n\n  .my-profile-subtitle {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
